<template>
    <div class="home">
        <div class="card">
            <div class="card-content">
                <div class="field">
                    <p class="control has-icons-left">
                        <input class="input" type="text" v-model="user.username" placeholder="Utilisateur" v-on:keyup.enter="login">
                        <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                        </span>
                    </p>
                </div>
                <div class="field">
                    <p class="control has-icons-left">
                        <input class="input" type="password" v-model="user.password" placeholder="Mot de passe" v-on:keyup.enter="login">
                        <span class="icon is-small is-left">
                        <i class="fas fa-lock"></i>
                        </span>
                    </p>
                </div>
                <div class="field">
                    <p class="control">
                        <button class="button is-success" @click="login">
                            Connexion
                        </button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '../router'
import netatmoService from '../services/netatmoService'

export default {
    data() {
        return {
            user: {}
        }
    },
    mounted() {
        if (this.$route.query.state && this.$route.query.state === netatmoService.state && this.$route.query.code) {
            netatmoService.netAtmoAuthenticate(this.$route.query.code)
            .then(() => {
                router.push('/')
                location.reload()                
            })
        }
    },
    methods: {
        login() {
            this.$store.dispatch('connecter', this.user)
            .then(() => {
                router.push('/')
                location.reload()
            })
        }
    }
}
</script>

<style scoped>
    .home {
        justify-content: center;
        flex-flow: row wrap;
        display: flex;
        align-content: stretch;
        align-items: stretch;
    }
</style>